/**
 * 
 * @param {SearchPiece} search
 * @param {Filtrator} filtrator
 */
export function linkSearchFiltrator(search, filtrator){
    search.fieldManager.load(filtrator.currentFilter)
    search.onFieldsChange.subscribe(filtrator.__searchChanged)
}